class TradeMultistepFormRedirect {
  constructor(element) {
    const redirectURL = element.dataset.redirectUrl;

    TradeMultistepFormRedirect.redirect(redirectURL);
  };

  static redirect(redirectURL) {
    window.location.href = redirectURL;
  };
};

export default TradeMultistepFormRedirect;
